import { useDomainAccessControl } from 'domains/shifts/utils/domain/accessControl'
import { Flipper } from 'domains/shifts/access-control/flippers'
import { ShiftType } from 'domains/shifts/components/types'
import { useIsRunnerDevicePrioritizationEnabled } from 'domains/shifts/utils/hooks/useIsRunnerDevicePrioritizationEnabled'

export const useIsDevicePrioritizationEnabled = ({
  shiftType,
  warehouseLocationId,
}: {
  shiftType: ShiftType
  warehouseLocationId: string
}): boolean => {
  const isRunnerDevicePrioritizationEnabled = useIsRunnerDevicePrioritizationEnabled({
    warehouseLocationId,
  })

  const hasAccess = useDomainAccessControl()
  const hasFeatureFlagAccess = hasAccess([
    { notWarehouseFlippers: Flipper.DisableDevicePrioritization },
  ])

  return (
    (hasFeatureFlagAccess && shiftType === ShiftType.Picking) ||
    (isRunnerDevicePrioritizationEnabled && shiftType === ShiftType.Running)
  )
}
